export const FEATURE_FORMS:any[] = [
    {

        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureTypeId", "productFeatureCategoryId", "description", "uomId", "numberSpecified", "defaultAmount", "defaultSequenceNum", "abbrev", "idCode" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureId",
            "title" : "ID"
        }, {
            "name" : "productFeatureTypeId",
            "title" : "Feature Type"
        }, {
            "name" : "productFeatureCategoryId",
            "title" : "Feature Category"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "uomId",
            "title" : "Unit of Measure ID"
        }, {
            "name" : "numberSpecified",
            "title" : "Quantity"
        }, {
            "name" : "defaultAmount",
            "title" : "Amount"
        }, {
            "name" : "defaultSequenceNum",
            "title" : "ID Seq Num"
        }, {
            "name" : "abbrev",
            "title" : "Abbrev"
        }, {
            "name" : "idCode",
            "title" : "ID Code"
        } ],
        "formName" : "ListProductFeatures",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "ID",
            "type" : "HYPERLINK",
            "target" : "EditFeature",
            "name" : "productFeatureId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureId"
            } ],
            "style" : "",
            "id" : "ListProductFeatures_productFeatureId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditFeature",
                "formLocation":"component://kwikstore/widget/FeatureForms.xml",
            },
            "event":"edit"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductFeatures",
            "options" : [ ],
            "disabled" : "false",
            "id" : "ListProductFeatures_productFeatureTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Category",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductFeatures",
            "options" : [ ],
            "disabled" : "false",
            "id" : "ListProductFeatures_productFeatureCategoryId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureCategoryId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Unit of Measure ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ListProductFeatures",
            "options" : [ ],
            "disabled" : "false",
            "id" : "ListProductFeatures_uomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "uomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "numberSpecified",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_numberSpecified",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Amount",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultAmount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_defaultAmount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Seq Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultSequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_defaultSequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Abbrev",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "abbrev",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_abbrev",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeatures_idCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureId", "productFeatureId", "productFeatureId", "productFeatureTypeId", "productFeatureCategoryId", "description", "uomId", "numberSpecified", "defaultAmount", "defaultSequenceNum", "abbrev", "idCode", "categoryLink", "submitButton" ]
        } ],
        "formName" : "EditProductFeature",
        "targets":{
            "createTarget":"createProductFeature",
            "updateTarget":"updateProductFeature"
        },
        "altTarget" : [ {
            "useWhen" : "productFeature==null",
            "targetExdr" : {
            "chars" : "createProductFeature",
            "hint" : 20,
            "empty" : false,
            "original" : "createProductFeature"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "id" : "EditProductFeature_productFeatureId",
            "name" : "productFeatureId",
            "type": "HIDDEN"
            },{
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductFeature",
            "options" : [ {
            "description" : "Accessory",
            "key" : "ACCESSORY"
            }, {
            "description" : "Amount",
            "key" : "AMOUNT"
            }, {
            "description" : "Artist",
            "key" : "ARTIST"
            }, {
            "description" : "Billing Feature",
            "key" : "BILLING_FEATURE"
            }, {
            "description" : "Brand",
            "key" : "BRAND"
            }, {
            "description" : "Care",
            "key" : "CARE"
            }, {
            "description" : "Color",
            "key" : "COLOR"
            }, {
            "description" : "Dimension",
            "key" : "DIMENSION"
            }, {
            "description" : "Equipment Class",
            "key" : "EQUIP_CLASS"
            }, {
            "description" : "Fabric",
            "key" : "FABRIC"
            }, {
            "description" : "Genre",
            "key" : "GENRE"
            }, {
            "description" : "Gift Wrap",
            "key" : "GIFT_WRAP"
            }, {
            "description" : "Hardware Feature",
            "key" : "HARDWARE_FEATURE"
            }, {
            "description" : "Hazmat",
            "key" : "HAZMAT"
            }, {
            "description" : "License",
            "key" : "LICENSE"
            }, {
            "description" : "Model Year",
            "key" : "MODEL_YEAR"
            }, {
            "description" : "Net Weight",
            "key" : "NET_WEIGHT"
            }, {
            "description" : "Origin",
            "key" : "ORIGIN"
            }, {
            "description" : "Other Feature",
            "key" : "OTHER_FEATURE"
            }, {
            "description" : "Product Quality",
            "key" : "PRODUCT_QUALITY"
            }, {
            "description" : "Size",
            "key" : "SIZE"
            }, {
            "description" : "Software Feature",
            "key" : "SOFTWARE_FEATURE"
            }, {
            "description" : "Style",
            "key" : "STYLE"
            }, {
            "description" : "Symptom",
            "key" : "SYMPTOM"
            }, {
            "description" : "Topic",
            "key" : "TOPIC"
            }, {
            "description" : "Type",
            "key" : "TYPE"
            }, {
            "description" : "Warranty",
            "key" : "WARRANTY"
            }, {
            "description" : "Year Made",
            "key" : "YEAR_MADE"
            } ],
            "disabled" : "false",
            "id" : "EditProductFeature_productFeatureTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Category",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductFeature",
            "options" : [ {
            "description" : "Account Features [2100]",
            "key" : "2100"
            }, {
            "description" : "Equipment Class Features [1002]",
            "key" : "1002"
            }, {
            "description" : "Gift Card Features [2000]",
            "key" : "2000"
            }, {
            "description" : "Hazmat Features [1000]",
            "key" : "1000"
            }, {
            "description" : "Image [IMAGE]",
            "key" : "IMAGE"
            }, {
            "description" : "License Features [8000]",
            "key" : "8000"
            }, {
            "description" : "Model Year Features [1001]",
            "key" : "1001"
            }, {
            "description" : "Scanning Type [SCAN_TYPE]",
            "key" : "SCAN_TYPE"
            }, {
            "description" : "Taste [3000]",
            "key" : "3000"
            }, {
            "description" : "Text [TEXT]",
            "key" : "TEXT"
            }, {
            "description" : "Widget Features [9000]",
            "key" : "9000"
            } ],
            "disabled" : "false",
            "id" : "EditProductFeature_productFeatureCategoryId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureCategoryId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Unit of Measure ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "uomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_uomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Number / Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "numberSpecified",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_numberSpecified",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Default Amount",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultAmount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_defaultAmount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Default Sequence Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultSequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_defaultSequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Abbreviation",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "abbrev",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_abbrev",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeature_idCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductFeature",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProductFeature_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductFeature"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productPriceTypeId", "currencyUomId", "fromDate", "thruDate", "price", "updateFeaturePrice", "lastModifiedBy", "deleteFeaturePrice" ]
        } ],
        "columns" : [ {
            "name" : "productPriceTypeId",
            "title" : "Price Type"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "price",
            "title" : "Price"
        }, {
            "name" : "updateFeaturePrice",
            "title" : "Update"
        }, {
            "name" : "lastModifiedBy",
            "title" : "Last Modified By"
        }, {
            "name" : "deleteFeaturePrice",
            "title" : "Delete"
        } ],
        "formName" : "ListFeaturePrice",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productFeatureId",
            "action" : "",
            "id" : "ListFeaturePrice_productFeatureId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "1000"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productPriceTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListFeaturePrice_productPriceTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListFeaturePrice_currencyUomId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListFeaturePrice_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListFeaturePrice",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListFeaturePrice_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "price",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListFeaturePrice_price",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListFeaturePrice",
            "tabindex" : "",
            "name" : "updateFeaturePrice",
            "className" : "smallSubmit",
            "id" : "ListFeaturePrice_updateFeaturePrice",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastModifiedBy",
            "description" : "[] On ",
            "style" : "",
            "id" : "ListFeaturePrice_lastModifiedBy",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "deleteFeaturePrice",
            "name" : "deleteFeaturePrice",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureId"
            }, {
            "name" : "productPriceTypeId"
            }, {
            "name" : "currencyUomId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListFeaturePrice_deleteFeaturePrice",
            "imageTitle" : "",
            "parameterMap" : {
            "productFeatureId" : "1000"
            },
            "height" : "",
            "formData":{
                "formName":"ListFeaturePrice",
                "formLocation":"component://kwikstore/widget/FeatureForms.xml"
            },
            "event":"delete"
        } ],
        "target" : "updateFeaturePrice"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productPriceTypeId", "fromDate", "thruDate", "price", "currencyUomId", "submitButton" ]
        } ],
        "formName" : "CreateFeaturePrice",
        "targets":{
            "createTarget":"createFeaturePrice"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productFeatureId",
            "action" : "",
            "id" : "CreateFeaturePrice_productFeatureId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "1000"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Price Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "DEFAULT_PRICE",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "CreateFeaturePrice",
            "options" : [ {
            "description" : "Average Cost",
            "key" : "AVERAGE_COST"
            }, {
            "description" : "Box Price",
            "key" : "BOX_PRICE"
            }, {
            "description" : "Competitive Price",
            "key" : "COMPETITIVE_PRICE"
            }, {
            "description" : "Default Price",
            "key" : "DEFAULT_PRICE"
            }, {
            "description" : "List Price",
            "key" : "LIST_PRICE"
            }, {
            "description" : "Maximum Price",
            "key" : "MAXIMUM_PRICE"
            }, {
            "description" : "Minimum Price",
            "key" : "MINIMUM_PRICE"
            }, {
            "description" : "Minimum order Price",
            "key" : "MINIMUM_ORDER_PRICE"
            }, {
            "description" : "Promotional Price",
            "key" : "PROMO_PRICE"
            }, {
            "description" : "Shipping Allowance Price",
            "key" : "SHIPPING_ALLOWANCE"
            }, {
            "description" : "Special Promo Price",
            "key" : "SPECIAL_PROMO_PRICE"
            }, {
            "description" : "Wholesale Price",
            "key" : "WHOLESALE_PRICE"
            } ],
            "disabled" : "false",
            "id" : "CreateFeaturePrice_productPriceTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productPriceTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-04-03%2016:56:49.371",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "CreateFeaturePrice",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "CreateFeaturePrice_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-04-03%2016:56:49.374",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "CreateFeaturePrice",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "CreateFeaturePrice_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "price",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateFeaturePrice_price",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "CreateFeaturePrice",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "CreateFeaturePrice_currencyUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "currencyUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "CreateFeaturePrice",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "CreateFeaturePrice_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createFeaturePrice"
    },
    {
        "columns" : [ {
            "name" : "partyId",
            "title" : "Suppliers"
        }, {
            "name" : "description",
            "title" : "Product Description"
        }, {
            "name" : "uomId",
            "title" : "Currency"
        }, {
            "name" : "idCode",
            "title" : "ID Code"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "EditSupplierProductFeatures",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productFeatureId",
            "action" : "",
            "id" : "EditSupplierProductFeatures_productFeatureId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "1000"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "EditSupplierProductFeatures_partyId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditSupplierProductFeatures_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditSupplierProductFeatures",
            "options" : [ {
            "description" : "CRC",
            "key" : "CRC"
            }, {
            "description" : "COP",
            "key" : "COP"
            }, {
            "description" : "CNY",
            "key" : "CNY"
            }, {
            "description" : "CLP",
            "key" : "CLP"
            }, {
            "description" : "CHF",
            "key" : "CHF"
            }, {
            "description" : "CAD",
            "key" : "CAD"
            }, {
            "description" : "BZD",
            "key" : "BZD"
            }, {
            "description" : "BYN",
            "key" : "BYN"
            }, {
            "description" : "BWP",
            "key" : "BWP"
            }, {
            "description" : "BSD",
            "key" : "BSD"
            }, {
            "description" : "BRL",
            "key" : "BRL"
            }, {
            "description" : "BOB",
            "key" : "BOB"
            }, {
            "description" : "BND",
            "key" : "BND"
            }, {
            "description" : "BMD",
            "key" : "BMD"
            }, {
            "description" : "BIF",
            "key" : "BIF"
            }, {
            "description" : "BHD",
            "key" : "BHD"
            }, {
            "description" : "BGN",
            "key" : "BGN"
            }, {
            "description" : "BDT",
            "key" : "BDT"
            }, {
            "description" : "BBD",
            "key" : "BBD"
            }, {
            "description" : "BAM",
            "key" : "BAM"
            }, {
            "description" : "AZN",
            "key" : "AZN"
            }, {
            "description" : "AWG",
            "key" : "AWG"
            }, {
            "description" : "AUD",
            "key" : "AUD"
            }, {
            "description" : "ARS",
            "key" : "ARS"
            }, {
            "description" : "AOA",
            "key" : "AOA"
            }, {
            "description" : "ANG",
            "key" : "ANG"
            }, {
            "description" : "AMD",
            "key" : "AMD"
            }, {
            "description" : "ALL",
            "key" : "ALL"
            }, {
            "description" : "AFN",
            "key" : "AFN"
            }, {
            "description" : "AED",
            "key" : "AED"
            }, {
            "description" : "CUP",
            "key" : "CUP"
            }, {
            "description" : "CVE",
            "key" : "CVE"
            }, {
            "description" : "CZK",
            "key" : "CZK"
            }, {
            "description" : "DJF",
            "key" : "DJF"
            }, {
            "description" : "DKK",
            "key" : "DKK"
            }, {
            "description" : "DOP",
            "key" : "DOP"
            }, {
            "description" : "DZD",
            "key" : "DZD"
            }, {
            "description" : "EGP",
            "key" : "EGP"
            }, {
            "description" : "ETB",
            "key" : "ETB"
            }, {
            "description" : "EUR",
            "key" : "EUR"
            }, {
            "description" : "FJD",
            "key" : "FJD"
            }, {
            "description" : "FKP",
            "key" : "FKP"
            }, {
            "description" : "GBP",
            "key" : "GBP"
            }, {
            "description" : "GEL",
            "key" : "GEL"
            }, {
            "description" : "GHS",
            "key" : "GHS"
            }, {
            "description" : "GIP",
            "key" : "GIP"
            }, {
            "description" : "GMD",
            "key" : "GMD"
            }, {
            "description" : "GNF",
            "key" : "GNF"
            }, {
            "description" : "GTQ",
            "key" : "GTQ"
            }, {
            "description" : "GYD",
            "key" : "GYD"
            }, {
            "description" : "HKD",
            "key" : "HKD"
            }, {
            "description" : "HNL",
            "key" : "HNL"
            }, {
            "description" : "HRK",
            "key" : "HRK"
            }, {
            "description" : "HTG",
            "key" : "HTG"
            }, {
            "description" : "HUF",
            "key" : "HUF"
            }, {
            "description" : "IDR",
            "key" : "IDR"
            }, {
            "description" : "INR",
            "key" : "INR"
            }, {
            "description" : "IQD",
            "key" : "IQD"
            }, {
            "description" : "IRR",
            "key" : "IRR"
            }, {
            "description" : "ISK",
            "key" : "ISK"
            }, {
            "description" : "JMD",
            "key" : "JMD"
            }, {
            "description" : "JOD",
            "key" : "JOD"
            }, {
            "description" : "JPY",
            "key" : "JPY"
            }, {
            "description" : "KES",
            "key" : "KES"
            }, {
            "description" : "KHR",
            "key" : "KHR"
            }, {
            "description" : "KGS",
            "key" : "KGS"
            }, {
            "description" : "KMF",
            "key" : "KMF"
            }, {
            "description" : "KPW",
            "key" : "KPW"
            }, {
            "description" : "KRW",
            "key" : "KRW"
            }, {
            "description" : "KWD",
            "key" : "KWD"
            }, {
            "description" : "KYD",
            "key" : "KYD"
            }, {
            "description" : "KZT",
            "key" : "KZT"
            }, {
            "description" : "LAK",
            "key" : "LAK"
            }, {
            "description" : "LBP",
            "key" : "LBP"
            }, {
            "description" : "LKR",
            "key" : "LKR"
            }, {
            "description" : "LRD",
            "key" : "LRD"
            }, {
            "description" : "LSL",
            "key" : "LSL"
            }, {
            "description" : "LYD",
            "key" : "LYD"
            }, {
            "description" : "MAD",
            "key" : "MAD"
            }, {
            "description" : "MDL",
            "key" : "MDL"
            }, {
            "description" : "MGA",
            "key" : "MGA"
            }, {
            "description" : "MNT",
            "key" : "MNT"
            }, {
            "description" : "MOP",
            "key" : "MOP"
            }, {
            "description" : "MRU",
            "key" : "MRU"
            }, {
            "description" : "MUR",
            "key" : "MUR"
            }, {
            "description" : "MVR",
            "key" : "MVR"
            }, {
            "description" : "MWK",
            "key" : "MWK"
            }, {
            "description" : "MXN",
            "key" : "MXN"
            }, {
            "description" : "MYR",
            "key" : "MYR"
            }, {
            "description" : "MZN",
            "key" : "MZN"
            }, {
            "description" : "NGN",
            "key" : "NGN"
            }, {
            "description" : "NIO",
            "key" : "NIO"
            }, {
            "description" : "ILS",
            "key" : "ILS"
            }, {
            "description" : "NOK",
            "key" : "NOK"
            }, {
            "description" : "NPR",
            "key" : "NPR"
            }, {
            "description" : "NZD",
            "key" : "NZD"
            }, {
            "description" : "OMR",
            "key" : "OMR"
            }, {
            "description" : "PAB",
            "key" : "PAB"
            }, {
            "description" : "PEN",
            "key" : "PEN"
            }, {
            "description" : "PGK",
            "key" : "PGK"
            }, {
            "description" : "PHP",
            "key" : "PHP"
            }, {
            "description" : "PKR",
            "key" : "PKR"
            }, {
            "description" : "PLN",
            "key" : "PLN"
            }, {
            "description" : "PYG",
            "key" : "PYG"
            }, {
            "description" : "QAR",
            "key" : "QAR"
            }, {
            "description" : "RON",
            "key" : "RON"
            }, {
            "description" : "RUB",
            "key" : "RUB"
            }, {
            "description" : "RWF",
            "key" : "RWF"
            }, {
            "description" : "SAR",
            "key" : "SAR"
            }, {
            "description" : "SBD",
            "key" : "SBD"
            }, {
            "description" : "SCR",
            "key" : "SCR"
            }, {
            "description" : "SDG",
            "key" : "SDG"
            }, {
            "description" : "SSP",
            "key" : "SSP"
            }, {
            "description" : "SEK",
            "key" : "SEK"
            }, {
            "description" : "SGD",
            "key" : "SGD"
            }, {
            "description" : "SHP",
            "key" : "SHP"
            }, {
            "description" : "SLL",
            "key" : "SLL"
            }, {
            "description" : "SOS",
            "key" : "SOS"
            }, {
            "description" : "SRD",
            "key" : "SRD"
            }, {
            "description" : "STN",
            "key" : "STN"
            }, {
            "description" : "SVC",
            "key" : "SVC"
            }, {
            "description" : "SYP",
            "key" : "SYP"
            }, {
            "description" : "SZL",
            "key" : "SZL"
            }, {
            "description" : "THB",
            "key" : "THB"
            }, {
            "description" : "TJS",
            "key" : "TJS"
            }, {
            "description" : "TMT",
            "key" : "TMT"
            }, {
            "description" : "TND",
            "key" : "TND"
            }, {
            "description" : "TOP",
            "key" : "TOP"
            }, {
            "description" : "TRY",
            "key" : "TRY"
            }, {
            "description" : "TTD",
            "key" : "TTD"
            }, {
            "description" : "TWD",
            "key" : "TWD"
            }, {
            "description" : "TZS",
            "key" : "TZS"
            }, {
            "description" : "UAH",
            "key" : "UAH"
            }, {
            "description" : "UGX",
            "key" : "UGX"
            }, {
            "description" : "USD",
            "key" : "USD"
            }, {
            "description" : "UYU",
            "key" : "UYU"
            }, {
            "description" : "UYI",
            "key" : "UYI"
            }, {
            "description" : "VES",
            "key" : "VES"
            }, {
            "description" : "VND",
            "key" : "VND"
            }, {
            "description" : "VUV",
            "key" : "VUV"
            }, {
            "description" : "WST",
            "key" : "WST"
            }, {
            "description" : "XAF",
            "key" : "XAF"
            }, {
            "description" : "XCD",
            "key" : "XCD"
            }, {
            "description" : "XOF",
            "key" : "XOF"
            }, {
            "description" : "YER",
            "key" : "YER"
            }, {
            "description" : "ZAR",
            "key" : "ZAR"
            }, {
            "description" : "ZMW",
            "key" : "ZMW"
            }, {
            "description" : "ZRN",
            "key" : "ZRN"
            }, {
            "description" : "ZWL",
            "key" : "ZWL"
            }, {
            "description" : "DATA_b",
            "key" : "DATA_b"
            }, {
            "description" : "DATA_Kb",
            "key" : "DATA_Kb"
            }, {
            "description" : "DATA_Mb",
            "key" : "DATA_Mb"
            }, {
            "description" : "DATA_Gb",
            "key" : "DATA_Gb"
            }, {
            "description" : "DATA_Tb",
            "key" : "DATA_Tb"
            }, {
            "description" : "DATA_Pb",
            "key" : "DATA_Pb"
            }, {
            "description" : "DATA_B",
            "key" : "DATA_B"
            }, {
            "description" : "DATA_KB",
            "key" : "DATA_KB"
            }, {
            "description" : "DATA_MB",
            "key" : "DATA_MB"
            }, {
            "description" : "DATA_GB",
            "key" : "DATA_GB"
            }, {
            "description" : "DATA_TB",
            "key" : "DATA_TB"
            }, {
            "description" : "DATA_PB",
            "key" : "DATA_PB"
            }, {
            "description" : "DATASPD_bps",
            "key" : "DATASPD_bps"
            }, {
            "description" : "DATASPD_Kbps",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "DATASPD_Mbps",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "DATASPD_Gbps",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "DATASPD_Tbps",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "TF_ms",
            "key" : "TF_ms"
            }, {
            "description" : "TF_s",
            "key" : "TF_s"
            }, {
            "description" : "TF_min",
            "key" : "TF_min"
            }, {
            "description" : "TF_hr",
            "key" : "TF_hr"
            }, {
            "description" : "TF_day",
            "key" : "TF_day"
            }, {
            "description" : "TF_wk",
            "key" : "TF_wk"
            }, {
            "description" : "TF_mon",
            "key" : "TF_mon"
            }, {
            "description" : "TF_yr",
            "key" : "TF_yr"
            }, {
            "description" : "TF_decade",
            "key" : "TF_decade"
            }, {
            "description" : "TF_score",
            "key" : "TF_score"
            }, {
            "description" : "TF_century",
            "key" : "TF_century"
            }, {
            "description" : "TF_millenium",
            "key" : "TF_millenium"
            }, {
            "description" : "LEN_A",
            "key" : "LEN_A"
            }, {
            "description" : "LEN_cb",
            "key" : "LEN_cb"
            }, {
            "description" : "LEN_cm",
            "key" : "LEN_cm"
            }, {
            "description" : "LEN_chG",
            "key" : "LEN_chG"
            }, {
            "description" : "LEN_chR",
            "key" : "LEN_chR"
            }, {
            "description" : "LEN_dm",
            "key" : "LEN_dm"
            }, {
            "description" : "LEN_dam",
            "key" : "LEN_dam"
            }, {
            "description" : "LEN_fm",
            "key" : "LEN_fm"
            }, {
            "description" : "LEN_ft",
            "key" : "LEN_ft"
            }, {
            "description" : "LEN_fur",
            "key" : "LEN_fur"
            }, {
            "description" : "LEN_hand",
            "key" : "LEN_hand"
            }, {
            "description" : "LEN_in",
            "key" : "LEN_in"
            }, {
            "description" : "LEN_km",
            "key" : "LEN_km"
            }, {
            "description" : "LEN_league",
            "key" : "LEN_league"
            }, {
            "description" : "LEN_lnG",
            "key" : "LEN_lnG"
            }, {
            "description" : "LEN_lnR",
            "key" : "LEN_lnR"
            }, {
            "description" : "LEN_m",
            "key" : "LEN_m"
            }, {
            "description" : "LEN_u",
            "key" : "LEN_u"
            }, {
            "description" : "LEN_mi",
            "key" : "LEN_mi"
            }, {
            "description" : "LEN_nmi",
            "key" : "LEN_nmi"
            }, {
            "description" : "LEN_mm",
            "key" : "LEN_mm"
            }, {
            "description" : "LEN_mil",
            "key" : "LEN_mil"
            }, {
            "description" : "LEN_point",
            "key" : "LEN_point"
            }, {
            "description" : "LEN_pica",
            "key" : "LEN_pica"
            }, {
            "description" : "LEN_rd",
            "key" : "LEN_rd"
            }, {
            "description" : "LEN_yd",
            "key" : "LEN_yd"
            }, {
            "description" : "AREA_A",
            "key" : "AREA_A"
            }, {
            "description" : "AREA_a",
            "key" : "AREA_a"
            }, {
            "description" : "AREA_ha",
            "key" : "AREA_ha"
            }, {
            "description" : "AREA_cm2",
            "key" : "AREA_cm2"
            }, {
            "description" : "AREA_ft2",
            "key" : "AREA_ft2"
            }, {
            "description" : "AREA_in2",
            "key" : "AREA_in2"
            }, {
            "description" : "AREA_km2",
            "key" : "AREA_km2"
            }, {
            "description" : "AREA_m2",
            "key" : "AREA_m2"
            }, {
            "description" : "AREA_mi2",
            "key" : "AREA_mi2"
            }, {
            "description" : "AREA_mm2",
            "key" : "AREA_mm2"
            }, {
            "description" : "AREA_rd2",
            "key" : "AREA_rd2"
            }, {
            "description" : "AREA_yd2",
            "key" : "AREA_yd2"
            }, {
            "description" : "VLIQ_bbl",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "VLIQ_cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "VLIQ_dr",
            "key" : "VLIQ_dr"
            }, {
            "description" : "VLIQ_gi",
            "key" : "VLIQ_gi"
            }, {
            "description" : "VLIQ_galUK",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "VLIQ_galUS",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "VLIQ_M3",
            "key" : "VLIQ_M3"
            }, {
            "description" : "VLIQ_HL",
            "key" : "VLIQ_HL"
            }, {
            "description" : "VLIQ_L",
            "key" : "VLIQ_L"
            }, {
            "description" : "VLIQ_ml",
            "key" : "VLIQ_ml"
            }, {
            "description" : "VLIQ_ozUK",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "VLIQ_ozUS",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "VLIQ_ptUK",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "VLIQ_ptUS",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "VLIQ_qt",
            "key" : "VLIQ_qt"
            }, {
            "description" : "VLIQ_Tbs",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "VLIQ_tsp",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "VDRY_cm3",
            "key" : "VDRY_cm3"
            }, {
            "description" : "VDRY_ft3",
            "key" : "VDRY_ft3"
            }, {
            "description" : "VDRY_in3",
            "key" : "VDRY_in3"
            }, {
            "description" : "VDRY_m3",
            "key" : "VDRY_m3"
            }, {
            "description" : "VDRY_mm3",
            "key" : "VDRY_mm3"
            }, {
            "description" : "VDRY_ST",
            "key" : "VDRY_ST"
            }, {
            "description" : "VDRY_yd3",
            "key" : "VDRY_yd3"
            }, {
            "description" : "WT_dr_avdp",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "WT_gr",
            "key" : "WT_gr"
            }, {
            "description" : "WT_g",
            "key" : "WT_g"
            }, {
            "description" : "WT_kg",
            "key" : "WT_kg"
            }, {
            "description" : "WT_mg",
            "key" : "WT_mg"
            }, {
            "description" : "WT_oz",
            "key" : "WT_oz"
            }, {
            "description" : "WT_oz_tr",
            "key" : "WT_oz_tr"
            }, {
            "description" : "WT_dwt",
            "key" : "WT_dwt"
            }, {
            "description" : "WT_lb",
            "key" : "WT_lb"
            }, {
            "description" : "WT_st",
            "key" : "WT_st"
            }, {
            "description" : "WT_lt",
            "key" : "WT_lt"
            }, {
            "description" : "WT_mt",
            "key" : "WT_mt"
            }, {
            "description" : "WT_sh_t",
            "key" : "WT_sh_t"
            }, {
            "description" : "EN_Btu",
            "key" : "EN_Btu"
            }, {
            "description" : "EN_cal15",
            "key" : "EN_cal15"
            }, {
            "description" : "EN_HP",
            "key" : "EN_HP"
            }, {
            "description" : "EN_J",
            "key" : "EN_J"
            }, {
            "description" : "EN_Kw",
            "key" : "EN_Kw"
            }, {
            "description" : "EN_w",
            "key" : "EN_w"
            }, {
            "description" : "TEMP_K",
            "key" : "TEMP_K"
            }, {
            "description" : "TEMP_C",
            "key" : "TEMP_C"
            }, {
            "description" : "TEMP_F",
            "key" : "TEMP_F"
            }, {
            "description" : "OTH_A",
            "key" : "OTH_A"
            }, {
            "description" : "OTH_cd",
            "key" : "OTH_cd"
            }, {
            "description" : "OTH_mol",
            "key" : "OTH_mol"
            }, {
            "description" : "OTH_ea",
            "key" : "OTH_ea"
            }, {
            "description" : "OTH_pp",
            "key" : "OTH_pp"
            }, {
            "description" : "OTH_box",
            "key" : "OTH_box"
            }, {
            "description" : "OTH_pk",
            "key" : "OTH_pk"
            } ],
            "disabled" : "false",
            "id" : "EditSupplierProductFeatures_uomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "uomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "5",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditSupplierProductFeatures_idCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditSupplierProductFeatures",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditSupplierProductFeatures_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "productFeatureId"
            }, {
            "name" : "partyId"
            } ],
            "id" : "EditSupplierProductFeatures_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "productFeatureId" : "1000"
            },
            "height" : "",
            "target" : "removeSupplierProductFeature"
        } ],
        "target" : "updateSupplierProductFeature"
    },
    {
        "formName" : "CreateSupplierProductFeature",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productFeatureId",
            "action" : "",
            "id" : "CreateSupplierProductFeature_productFeatureId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "1000"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Suppliers",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "CreateSupplierProductFeature",
            "options" : [ {
            "description" : "Acct Big Supplier   [AcctBigSupplier]",
            "key" : "AcctBigSupplier"
            }, {
            "description" : "Big Supplier   [BigSupplier]",
            "key" : "BigSupplier"
            }, {
            "description" : "Demo Supplier   [DemoSupplier]",
            "key" : "DemoSupplier"
            }, {
            "description" : "European Supplier   [EuroSupplier]",
            "key" : "EuroSupplier"
            }, {
            "description" : " External User [externaluser]",
            "key" : "externaluser"
            } ],
            "disabled" : "false",
            "id" : "CreateSupplierProductFeature_partyId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "partyId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateSupplierProductFeature_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "CreateSupplierProductFeature",
            "options" : [ {
            "description" : "CRC",
            "key" : "CRC"
            }, {
            "description" : "COP",
            "key" : "COP"
            }, {
            "description" : "CNY",
            "key" : "CNY"
            }, {
            "description" : "CLP",
            "key" : "CLP"
            }, {
            "description" : "CHF",
            "key" : "CHF"
            }, {
            "description" : "CAD",
            "key" : "CAD"
            }, {
            "description" : "BZD",
            "key" : "BZD"
            }, {
            "description" : "BYN",
            "key" : "BYN"
            }, {
            "description" : "BWP",
            "key" : "BWP"
            }, {
            "description" : "BSD",
            "key" : "BSD"
            }, {
            "description" : "BRL",
            "key" : "BRL"
            }, {
            "description" : "BOB",
            "key" : "BOB"
            }, {
            "description" : "BND",
            "key" : "BND"
            }, {
            "description" : "BMD",
            "key" : "BMD"
            }, {
            "description" : "BIF",
            "key" : "BIF"
            }, {
            "description" : "BHD",
            "key" : "BHD"
            }, {
            "description" : "BGN",
            "key" : "BGN"
            }, {
            "description" : "BDT",
            "key" : "BDT"
            }, {
            "description" : "BBD",
            "key" : "BBD"
            }, {
            "description" : "BAM",
            "key" : "BAM"
            }, {
            "description" : "AZN",
            "key" : "AZN"
            }, {
            "description" : "AWG",
            "key" : "AWG"
            }, {
            "description" : "AUD",
            "key" : "AUD"
            }, {
            "description" : "ARS",
            "key" : "ARS"
            }, {
            "description" : "AOA",
            "key" : "AOA"
            }, {
            "description" : "ANG",
            "key" : "ANG"
            }, {
            "description" : "AMD",
            "key" : "AMD"
            }, {
            "description" : "ALL",
            "key" : "ALL"
            }, {
            "description" : "AFN",
            "key" : "AFN"
            }, {
            "description" : "AED",
            "key" : "AED"
            }, {
            "description" : "CUP",
            "key" : "CUP"
            }, {
            "description" : "CVE",
            "key" : "CVE"
            }, {
            "description" : "CZK",
            "key" : "CZK"
            }, {
            "description" : "DJF",
            "key" : "DJF"
            }, {
            "description" : "DKK",
            "key" : "DKK"
            }, {
            "description" : "DOP",
            "key" : "DOP"
            }, {
            "description" : "DZD",
            "key" : "DZD"
            }, {
            "description" : "EGP",
            "key" : "EGP"
            }, {
            "description" : "ETB",
            "key" : "ETB"
            }, {
            "description" : "EUR",
            "key" : "EUR"
            }, {
            "description" : "FJD",
            "key" : "FJD"
            }, {
            "description" : "FKP",
            "key" : "FKP"
            }, {
            "description" : "GBP",
            "key" : "GBP"
            }, {
            "description" : "GEL",
            "key" : "GEL"
            }, {
            "description" : "GHS",
            "key" : "GHS"
            }, {
            "description" : "GIP",
            "key" : "GIP"
            }, {
            "description" : "GMD",
            "key" : "GMD"
            }, {
            "description" : "GNF",
            "key" : "GNF"
            }, {
            "description" : "GTQ",
            "key" : "GTQ"
            }, {
            "description" : "GYD",
            "key" : "GYD"
            }, {
            "description" : "HKD",
            "key" : "HKD"
            }, {
            "description" : "HNL",
            "key" : "HNL"
            }, {
            "description" : "HRK",
            "key" : "HRK"
            }, {
            "description" : "HTG",
            "key" : "HTG"
            }, {
            "description" : "HUF",
            "key" : "HUF"
            }, {
            "description" : "IDR",
            "key" : "IDR"
            }, {
            "description" : "INR",
            "key" : "INR"
            }, {
            "description" : "IQD",
            "key" : "IQD"
            }, {
            "description" : "IRR",
            "key" : "IRR"
            }, {
            "description" : "ISK",
            "key" : "ISK"
            }, {
            "description" : "JMD",
            "key" : "JMD"
            }, {
            "description" : "JOD",
            "key" : "JOD"
            }, {
            "description" : "JPY",
            "key" : "JPY"
            }, {
            "description" : "KES",
            "key" : "KES"
            }, {
            "description" : "KHR",
            "key" : "KHR"
            }, {
            "description" : "KGS",
            "key" : "KGS"
            }, {
            "description" : "KMF",
            "key" : "KMF"
            }, {
            "description" : "KPW",
            "key" : "KPW"
            }, {
            "description" : "KRW",
            "key" : "KRW"
            }, {
            "description" : "KWD",
            "key" : "KWD"
            }, {
            "description" : "KYD",
            "key" : "KYD"
            }, {
            "description" : "KZT",
            "key" : "KZT"
            }, {
            "description" : "LAK",
            "key" : "LAK"
            }, {
            "description" : "LBP",
            "key" : "LBP"
            }, {
            "description" : "LKR",
            "key" : "LKR"
            }, {
            "description" : "LRD",
            "key" : "LRD"
            }, {
            "description" : "LSL",
            "key" : "LSL"
            }, {
            "description" : "LYD",
            "key" : "LYD"
            }, {
            "description" : "MAD",
            "key" : "MAD"
            }, {
            "description" : "MDL",
            "key" : "MDL"
            }, {
            "description" : "MGA",
            "key" : "MGA"
            }, {
            "description" : "MNT",
            "key" : "MNT"
            }, {
            "description" : "MOP",
            "key" : "MOP"
            }, {
            "description" : "MRU",
            "key" : "MRU"
            }, {
            "description" : "MUR",
            "key" : "MUR"
            }, {
            "description" : "MVR",
            "key" : "MVR"
            }, {
            "description" : "MWK",
            "key" : "MWK"
            }, {
            "description" : "MXN",
            "key" : "MXN"
            }, {
            "description" : "MYR",
            "key" : "MYR"
            }, {
            "description" : "MZN",
            "key" : "MZN"
            }, {
            "description" : "NGN",
            "key" : "NGN"
            }, {
            "description" : "NIO",
            "key" : "NIO"
            }, {
            "description" : "ILS",
            "key" : "ILS"
            }, {
            "description" : "NOK",
            "key" : "NOK"
            }, {
            "description" : "NPR",
            "key" : "NPR"
            }, {
            "description" : "NZD",
            "key" : "NZD"
            }, {
            "description" : "OMR",
            "key" : "OMR"
            }, {
            "description" : "PAB",
            "key" : "PAB"
            }, {
            "description" : "PEN",
            "key" : "PEN"
            }, {
            "description" : "PGK",
            "key" : "PGK"
            }, {
            "description" : "PHP",
            "key" : "PHP"
            }, {
            "description" : "PKR",
            "key" : "PKR"
            }, {
            "description" : "PLN",
            "key" : "PLN"
            }, {
            "description" : "PYG",
            "key" : "PYG"
            }, {
            "description" : "QAR",
            "key" : "QAR"
            }, {
            "description" : "RON",
            "key" : "RON"
            }, {
            "description" : "RUB",
            "key" : "RUB"
            }, {
            "description" : "RWF",
            "key" : "RWF"
            }, {
            "description" : "SAR",
            "key" : "SAR"
            }, {
            "description" : "SBD",
            "key" : "SBD"
            }, {
            "description" : "SCR",
            "key" : "SCR"
            }, {
            "description" : "SDG",
            "key" : "SDG"
            }, {
            "description" : "SSP",
            "key" : "SSP"
            }, {
            "description" : "SEK",
            "key" : "SEK"
            }, {
            "description" : "SGD",
            "key" : "SGD"
            }, {
            "description" : "SHP",
            "key" : "SHP"
            }, {
            "description" : "SLL",
            "key" : "SLL"
            }, {
            "description" : "SOS",
            "key" : "SOS"
            }, {
            "description" : "SRD",
            "key" : "SRD"
            }, {
            "description" : "STN",
            "key" : "STN"
            }, {
            "description" : "SVC",
            "key" : "SVC"
            }, {
            "description" : "SYP",
            "key" : "SYP"
            }, {
            "description" : "SZL",
            "key" : "SZL"
            }, {
            "description" : "THB",
            "key" : "THB"
            }, {
            "description" : "TJS",
            "key" : "TJS"
            }, {
            "description" : "TMT",
            "key" : "TMT"
            }, {
            "description" : "TND",
            "key" : "TND"
            }, {
            "description" : "TOP",
            "key" : "TOP"
            }, {
            "description" : "TRY",
            "key" : "TRY"
            }, {
            "description" : "TTD",
            "key" : "TTD"
            }, {
            "description" : "TWD",
            "key" : "TWD"
            }, {
            "description" : "TZS",
            "key" : "TZS"
            }, {
            "description" : "UAH",
            "key" : "UAH"
            }, {
            "description" : "UGX",
            "key" : "UGX"
            }, {
            "description" : "USD",
            "key" : "USD"
            }, {
            "description" : "UYU",
            "key" : "UYU"
            }, {
            "description" : "UYI",
            "key" : "UYI"
            }, {
            "description" : "VES",
            "key" : "VES"
            }, {
            "description" : "VND",
            "key" : "VND"
            }, {
            "description" : "VUV",
            "key" : "VUV"
            }, {
            "description" : "WST",
            "key" : "WST"
            }, {
            "description" : "XAF",
            "key" : "XAF"
            }, {
            "description" : "XCD",
            "key" : "XCD"
            }, {
            "description" : "XOF",
            "key" : "XOF"
            }, {
            "description" : "YER",
            "key" : "YER"
            }, {
            "description" : "ZAR",
            "key" : "ZAR"
            }, {
            "description" : "ZMW",
            "key" : "ZMW"
            }, {
            "description" : "ZRN",
            "key" : "ZRN"
            }, {
            "description" : "ZWL",
            "key" : "ZWL"
            }, {
            "description" : "DATA_b",
            "key" : "DATA_b"
            }, {
            "description" : "DATA_Kb",
            "key" : "DATA_Kb"
            }, {
            "description" : "DATA_Mb",
            "key" : "DATA_Mb"
            }, {
            "description" : "DATA_Gb",
            "key" : "DATA_Gb"
            }, {
            "description" : "DATA_Tb",
            "key" : "DATA_Tb"
            }, {
            "description" : "DATA_Pb",
            "key" : "DATA_Pb"
            }, {
            "description" : "DATA_B",
            "key" : "DATA_B"
            }, {
            "description" : "DATA_KB",
            "key" : "DATA_KB"
            }, {
            "description" : "DATA_MB",
            "key" : "DATA_MB"
            }, {
            "description" : "DATA_GB",
            "key" : "DATA_GB"
            }, {
            "description" : "DATA_TB",
            "key" : "DATA_TB"
            }, {
            "description" : "DATA_PB",
            "key" : "DATA_PB"
            }, {
            "description" : "DATASPD_bps",
            "key" : "DATASPD_bps"
            }, {
            "description" : "DATASPD_Kbps",
            "key" : "DATASPD_Kbps"
            }, {
            "description" : "DATASPD_Mbps",
            "key" : "DATASPD_Mbps"
            }, {
            "description" : "DATASPD_Gbps",
            "key" : "DATASPD_Gbps"
            }, {
            "description" : "DATASPD_Tbps",
            "key" : "DATASPD_Tbps"
            }, {
            "description" : "TF_ms",
            "key" : "TF_ms"
            }, {
            "description" : "TF_s",
            "key" : "TF_s"
            }, {
            "description" : "TF_min",
            "key" : "TF_min"
            }, {
            "description" : "TF_hr",
            "key" : "TF_hr"
            }, {
            "description" : "TF_day",
            "key" : "TF_day"
            }, {
            "description" : "TF_wk",
            "key" : "TF_wk"
            }, {
            "description" : "TF_mon",
            "key" : "TF_mon"
            }, {
            "description" : "TF_yr",
            "key" : "TF_yr"
            }, {
            "description" : "TF_decade",
            "key" : "TF_decade"
            }, {
            "description" : "TF_score",
            "key" : "TF_score"
            }, {
            "description" : "TF_century",
            "key" : "TF_century"
            }, {
            "description" : "TF_millenium",
            "key" : "TF_millenium"
            }, {
            "description" : "LEN_A",
            "key" : "LEN_A"
            }, {
            "description" : "LEN_cb",
            "key" : "LEN_cb"
            }, {
            "description" : "LEN_cm",
            "key" : "LEN_cm"
            }, {
            "description" : "LEN_chG",
            "key" : "LEN_chG"
            }, {
            "description" : "LEN_chR",
            "key" : "LEN_chR"
            }, {
            "description" : "LEN_dm",
            "key" : "LEN_dm"
            }, {
            "description" : "LEN_dam",
            "key" : "LEN_dam"
            }, {
            "description" : "LEN_fm",
            "key" : "LEN_fm"
            }, {
            "description" : "LEN_ft",
            "key" : "LEN_ft"
            }, {
            "description" : "LEN_fur",
            "key" : "LEN_fur"
            }, {
            "description" : "LEN_hand",
            "key" : "LEN_hand"
            }, {
            "description" : "LEN_in",
            "key" : "LEN_in"
            }, {
            "description" : "LEN_km",
            "key" : "LEN_km"
            }, {
            "description" : "LEN_league",
            "key" : "LEN_league"
            }, {
            "description" : "LEN_lnG",
            "key" : "LEN_lnG"
            }, {
            "description" : "LEN_lnR",
            "key" : "LEN_lnR"
            }, {
            "description" : "LEN_m",
            "key" : "LEN_m"
            }, {
            "description" : "LEN_u",
            "key" : "LEN_u"
            }, {
            "description" : "LEN_mi",
            "key" : "LEN_mi"
            }, {
            "description" : "LEN_nmi",
            "key" : "LEN_nmi"
            }, {
            "description" : "LEN_mm",
            "key" : "LEN_mm"
            }, {
            "description" : "LEN_mil",
            "key" : "LEN_mil"
            }, {
            "description" : "LEN_point",
            "key" : "LEN_point"
            }, {
            "description" : "LEN_pica",
            "key" : "LEN_pica"
            }, {
            "description" : "LEN_rd",
            "key" : "LEN_rd"
            }, {
            "description" : "LEN_yd",
            "key" : "LEN_yd"
            }, {
            "description" : "AREA_A",
            "key" : "AREA_A"
            }, {
            "description" : "AREA_a",
            "key" : "AREA_a"
            }, {
            "description" : "AREA_ha",
            "key" : "AREA_ha"
            }, {
            "description" : "AREA_cm2",
            "key" : "AREA_cm2"
            }, {
            "description" : "AREA_ft2",
            "key" : "AREA_ft2"
            }, {
            "description" : "AREA_in2",
            "key" : "AREA_in2"
            }, {
            "description" : "AREA_km2",
            "key" : "AREA_km2"
            }, {
            "description" : "AREA_m2",
            "key" : "AREA_m2"
            }, {
            "description" : "AREA_mi2",
            "key" : "AREA_mi2"
            }, {
            "description" : "AREA_mm2",
            "key" : "AREA_mm2"
            }, {
            "description" : "AREA_rd2",
            "key" : "AREA_rd2"
            }, {
            "description" : "AREA_yd2",
            "key" : "AREA_yd2"
            }, {
            "description" : "VLIQ_bbl",
            "key" : "VLIQ_bbl"
            }, {
            "description" : "VLIQ_cup",
            "key" : "VLIQ_cup"
            }, {
            "description" : "VLIQ_dr",
            "key" : "VLIQ_dr"
            }, {
            "description" : "VLIQ_gi",
            "key" : "VLIQ_gi"
            }, {
            "description" : "VLIQ_galUK",
            "key" : "VLIQ_galUK"
            }, {
            "description" : "VLIQ_galUS",
            "key" : "VLIQ_galUS"
            }, {
            "description" : "VLIQ_M3",
            "key" : "VLIQ_M3"
            }, {
            "description" : "VLIQ_HL",
            "key" : "VLIQ_HL"
            }, {
            "description" : "VLIQ_L",
            "key" : "VLIQ_L"
            }, {
            "description" : "VLIQ_ml",
            "key" : "VLIQ_ml"
            }, {
            "description" : "VLIQ_ozUK",
            "key" : "VLIQ_ozUK"
            }, {
            "description" : "VLIQ_ozUS",
            "key" : "VLIQ_ozUS"
            }, {
            "description" : "VLIQ_ptUK",
            "key" : "VLIQ_ptUK"
            }, {
            "description" : "VLIQ_ptUS",
            "key" : "VLIQ_ptUS"
            }, {
            "description" : "VLIQ_qt",
            "key" : "VLIQ_qt"
            }, {
            "description" : "VLIQ_Tbs",
            "key" : "VLIQ_Tbs"
            }, {
            "description" : "VLIQ_tsp",
            "key" : "VLIQ_tsp"
            }, {
            "description" : "VDRY_cm3",
            "key" : "VDRY_cm3"
            }, {
            "description" : "VDRY_ft3",
            "key" : "VDRY_ft3"
            }, {
            "description" : "VDRY_in3",
            "key" : "VDRY_in3"
            }, {
            "description" : "VDRY_m3",
            "key" : "VDRY_m3"
            }, {
            "description" : "VDRY_mm3",
            "key" : "VDRY_mm3"
            }, {
            "description" : "VDRY_ST",
            "key" : "VDRY_ST"
            }, {
            "description" : "VDRY_yd3",
            "key" : "VDRY_yd3"
            }, {
            "description" : "WT_dr_avdp",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "WT_gr",
            "key" : "WT_gr"
            }, {
            "description" : "WT_g",
            "key" : "WT_g"
            }, {
            "description" : "WT_kg",
            "key" : "WT_kg"
            }, {
            "description" : "WT_mg",
            "key" : "WT_mg"
            }, {
            "description" : "WT_oz",
            "key" : "WT_oz"
            }, {
            "description" : "WT_oz_tr",
            "key" : "WT_oz_tr"
            }, {
            "description" : "WT_dwt",
            "key" : "WT_dwt"
            }, {
            "description" : "WT_lb",
            "key" : "WT_lb"
            }, {
            "description" : "WT_st",
            "key" : "WT_st"
            }, {
            "description" : "WT_lt",
            "key" : "WT_lt"
            }, {
            "description" : "WT_mt",
            "key" : "WT_mt"
            }, {
            "description" : "WT_sh_t",
            "key" : "WT_sh_t"
            }, {
            "description" : "EN_Btu",
            "key" : "EN_Btu"
            }, {
            "description" : "EN_cal15",
            "key" : "EN_cal15"
            }, {
            "description" : "EN_HP",
            "key" : "EN_HP"
            }, {
            "description" : "EN_J",
            "key" : "EN_J"
            }, {
            "description" : "EN_Kw",
            "key" : "EN_Kw"
            }, {
            "description" : "EN_w",
            "key" : "EN_w"
            }, {
            "description" : "TEMP_K",
            "key" : "TEMP_K"
            }, {
            "description" : "TEMP_C",
            "key" : "TEMP_C"
            }, {
            "description" : "TEMP_F",
            "key" : "TEMP_F"
            }, {
            "description" : "OTH_A",
            "key" : "OTH_A"
            }, {
            "description" : "OTH_cd",
            "key" : "OTH_cd"
            }, {
            "description" : "OTH_mol",
            "key" : "OTH_mol"
            }, {
            "description" : "OTH_ea",
            "key" : "OTH_ea"
            }, {
            "description" : "OTH_pp",
            "key" : "OTH_pp"
            }, {
            "description" : "OTH_box",
            "key" : "OTH_box"
            }, {
            "description" : "OTH_pk",
            "key" : "OTH_pk"
            } ],
            "disabled" : "false",
            "id" : "CreateSupplierProductFeature_uomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "uomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateSupplierProductFeature_idCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "CreateSupplierProductFeature",
            "tabindex" : "",
            "name" : "submitForm",
            "className" : "",
            "id" : "CreateSupplierProductFeature_submitForm",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createSupplierProductFeature"
    },
]